import { render, staticRenderFns } from "./MobileClientRow.vue?vue&type=template&id=f22e882a&scoped=true&"
import script from "./MobileClientRow.vue?vue&type=script&lang=js&"
export * from "./MobileClientRow.vue?vue&type=script&lang=js&"
import style0 from "./MobileClientRow.vue?vue&type=style&index=0&id=f22e882a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e882a",
  null
  
)

export default component.exports